/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as ConfigurationRouteImport } from './routes/configuration'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as AuditTrailRouteImport } from './routes/audit-trail'
import { Route as IndexRouteImport } from './routes/index'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationRoute = ConfigurationRouteImport.update({
  id: '/configuration',
  path: '/configuration',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditTrailRoute = AuditTrailRouteImport.update({
  id: '/audit-trail',
  path: '/audit-trail',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit-trail': typeof AuditTrailRoute
  '/chat': typeof ChatRoute
  '/configuration': typeof ConfigurationRoute
  '/profile': typeof ProfileRoute
  '/users': typeof UsersRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit-trail': typeof AuditTrailRoute
  '/chat': typeof ChatRoute
  '/configuration': typeof ConfigurationRoute
  '/profile': typeof ProfileRoute
  '/users': typeof UsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audit-trail': typeof AuditTrailRoute
  '/chat': typeof ChatRoute
  '/configuration': typeof ConfigurationRoute
  '/profile': typeof ProfileRoute
  '/users': typeof UsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit-trail'
    | '/chat'
    | '/configuration'
    | '/profile'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/audit-trail' | '/chat' | '/configuration' | '/profile' | '/users'
  id:
    | '__root__'
    | '/'
    | '/audit-trail'
    | '/chat'
    | '/configuration'
    | '/profile'
    | '/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuditTrailRoute: typeof AuditTrailRoute
  ChatRoute: typeof ChatRoute
  ConfigurationRoute: typeof ConfigurationRoute
  ProfileRoute: typeof ProfileRoute
  UsersRoute: typeof UsersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration': {
      id: '/configuration'
      path: '/configuration'
      fullPath: '/configuration'
      preLoaderRoute: typeof ConfigurationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit-trail': {
      id: '/audit-trail'
      path: '/audit-trail'
      fullPath: '/audit-trail'
      preLoaderRoute: typeof AuditTrailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditTrailRoute: AuditTrailRoute,
  ChatRoute: ChatRoute,
  ConfigurationRoute: ConfigurationRoute,
  ProfileRoute: ProfileRoute,
  UsersRoute: UsersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
